import { useQuery } from "react-query";
import { LoyaltyApi } from "@jti/rest-api";
import { useConfig } from "../../../providers/useConfig";
const fetchContestsBackendConfig = async (ciam_token, uuid) => {
    if (!ciam_token || !uuid) {
        throw new Error("Missing ciam_token or uuid");
    }
    const apiInstance = LoyaltyApi.init();
    const result = await apiInstance.getContestStatus(uuid, ciam_token);
    return result;
};
export const useContestsBackendConfig = ({ ciam_token, uuid, isInEditor = false, }) => {
    const { isLoyaltyContestsServiceEnabled } = useConfig();
    const { data, isLoading, error } = useQuery(["backendConfig", ciam_token, uuid], () => fetchContestsBackendConfig(ciam_token, uuid), {
        enabled: Boolean(ciam_token && uuid && isLoyaltyContestsServiceEnabled && !isInEditor),
        retry: false,
    });
    return {
        contestsBackedConfig: data || null,
        isContestsBackendConfigLoading: isLoading,
        isContestsBackendConfigError: error ? error : null,
    };
};
//# sourceMappingURL=useContestsBackendConfig.js.map